export function base64ToBlob(base64, contentType = "image/jpeg") {

  if (!base64 || typeof base64 !== "string") {
    console.warn("Invalid base64 input", base64);
    return null;
  }

  if (base64.includes(",")) {
    base64 = base64.split(",")[1];
  }

  base64 = base64.replace(/-/g, "+").replace(/_/g, "/");

  let byteCharacters;
  try {
    byteCharacters = atob(base64);
  } catch (err) {
    console.error("atob failed for base64", err);
    return null;
  }

  const byteArrays = [];
  const sliceSize = 1024;

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);

    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    byteArrays.push(new Uint8Array(byteNumbers));
  }

  return new Blob(byteArrays, { type: contentType });
}
